import { observable, toJS } from 'mobx';

export default class ServiceModel {
    id = null;
    @observable dmrn = null;
    @observable name = null;
    @observable type = null;
    @observable provider = null;
    @observable credentialId = null;
    @observable aws = null;

    // Virtual Fields
    @observable operations = null;

    auth = null;

    // Operations
    readOperation(dmrn) {
        if (this.operations) {
            switch (this.operations.type) {
            case 'presigned_url':
                return this.auth.apiGet(`/api/services/${this.id}${this.operations.endpoints.read}?dmrn=${dmrn}`)
                    .then(data => data);
            default:
                // TODO WARN !
                return null;
            }
        }
        // TODO Warn
        return null;
    }

    constructor(auth, id, dmrn, name, type, provider, credentialId, operations, aws) {
        this.auth = auth;
        this.id = id;
        this.dmrn = dmrn;
        this.name = name;
        this.type = type;
        this.provider = provider;
        this.credentialId = credentialId;

        this.operations = operations;

        this.aws = aws;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(auth, object) {
        return new ServiceModel(
            auth, object.id, object.dmrn, object.name, object.type,
            object.provider, object.credential_id, object.operations, object.aws,
        );
    }
}
